import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { ROOT_URL } from '../../../config/global.js';
import { strings } from './FormSignUpContent';

//Components
import TextHeadingOne from '../../atoms/TextHeadingTwo';
import TextParagraph from '../../atoms/TextParagraph';
import FormButton from '../../atoms/FormButton';
import LabeledTextfield from '../../molecules/LabeledTextfield';
import FormCheckbox from '../../atoms/FormCheckbox';


//Returning the component
class FormSignUp extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			nameInput: '',
			emailInput: '',
			passwordInput: '',
			verifyInput: '',
			verifyError: '',
			registered: false,
			buttonData: {
				text: strings.formButtonText,
				class: 'btn--disabled'
			}
		}

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.renderHandler = this.renderHandler.bind(this);
		this.confirmChange = this.confirmChange.bind(this);
	}
	componentWillMount() {
		// Reads the language from the store
		strings.setLanguage(this.props.language);
	}
	componentWillReceiveProps(nextProps) {
		strings.setLanguage(nextProps.language.data);
	}
	handleSubmit(e) {
		e.preventDefault();
		if (this.state.passwordInput !== this.state.verifyInput) {
			this.setState({ verifyError: 'form__group--error' })
			return;
		}
		const signupRequest = axios({
            method: 'post',
            url: `${ROOT_URL}/api/auth/signup`,
            data: {
				name: this.state.nameInput, //Test
                email: this.state.emailInput, //daniel@frankie.se
				password: this.state.passwordInput,
				passwordRepeat: this.state.passwordInput
            }
        });

		// Adding loading state
		this.setState({ 
			buttonData: {
				text: '',
				class: 'btn--disabled',
				loadingIcon: 'fa fa-spinner fa-pulse fa-2x fa-fw'
			}
		 });

        // Updates the store with the new login status
        signupRequest.then(() => { 
            this.setState({ 
				nameInput: '',
                emailInput: '',
                passwordInput: '',
				verifyInput: '',
				registered: true
			});
        }).catch((error) => {
			this.setState({ 
				buttonData: {
					text: strings.errorMessage,
					class: 'btn--error',
					loadingIcon: ''
				}
			}, () => {
				setTimeout(() => { this.setState({ 
					buttonData: {
						text: strings.formButtonText,
						class: '' 
					}
				}) }, 3000);
			});
		});
	}
	confirmChange(e) {
		// Trigger onBlur, updates the state on auto-fill events
		this.handleChange(e);
	}
	handleChange(e) {
		let targetValue = e.target.value;
		if (e.target.type === 'checkbox') {
			targetValue = e.target.checked;
		}

		this.setState({
			[e.target.name]: targetValue,
			verifyError: ''
        },() => {
			if (this.state.nameInput && this.state.emailInput && this.state.passwordInput && this.state.verifyInput && this.state.terms) {
				this.setState({
					buttonData: {
						text: strings.formButtonText,
						class: ''
					}
				});
			} else {
				this.setState({
					buttonData: {
						text: strings.formButtonText,
						class: 'btn--disabled'
					}
				});
			}
		});
	}
	renderHandler() {
		if (this.state.registered) {
			return (
				<Redirect to={{
					pathname: '/verify',
					state: { from: this.props.location, storeLoginStatus: true } // This is the store state
				}}/>
			)
		} else {
			return (
				<form onSubmit={this.handleSubmit} className={`form formSignup ${this.props.formWrapperClassType}`}>
					<TextHeadingOne text={strings.textHeadingOne} />
					<TextParagraph text={strings.textParagraph} />
	
					{/* Full Name */}
					<LabeledTextfield 
						formGroupClassType={this.props.formGroupClassType}
						labelFor={strings.fullName}
						labelText={strings.fullName}
						labelId={strings.fullName}
						textfieldClassType={this.props.textfieldClassType}
						textfieldId={strings.fullName}
						textfieldPlaceholder={strings.fullName}
						textfieldName='nameInput'
						value={this.state.nameInput}
						textfieldForm={this.props.textFieldForm}
						onChange={this.handleChange}
						onBlur={this.confirmChange}
						errorMessageClassType={this.props.errorMessageClassType}
						errorMessageText={strings.errorMessageFullName}
						required={true}
					/>
	
					{/* Email */}
					<LabeledTextfield 
						formGroupClassType={this.props.formGroupClassType}
						labelFor={this.props.email} labelText={strings.email}
						labelId={strings.email}
						textfieldClassType={this.props.textfieldClassType}
						textfieldId={strings.email}
						textfieldPlaceholder={strings.email}
						textfieldName='emailInput'
						value={this.state.emailInput}
						textfieldForm={this.props.textFieldForm}
						onChange={this.handleChange}
						onBlur={this.confirmChange}
						errorMessageClassType={this.props.errorMessageClassType}
						errorMessageText={strings.errorMessageEmail}
						required={true} 
					/>
	
					{/* Password */}
					<LabeledTextfield
						formGroupClassType={this.props.formGroupClassType}
						labelFor={strings.password}
						labelText={strings.password}
						inputType='password'
						labelId={strings.password}
						textfieldClassType={this.props.textfieldClassType}
						textfieldId={strings.password}
						textfieldPlaceholder={strings.password}
						textfieldName='passwordInput'
						value={this.state.passwordInput}
						textfieldForm={this.props.textFieldForm}
						onChange={this.handleChange}
						onBlur={this.confirmChange}
						errorMessageClassType={this.props.errorMessageClassType}
						errorMessageText={strings.errorMessagePassword}
						required={true}
					/>

					{/* Verify password */}
					<LabeledTextfield 
						formGroupClassType={this.state.verifyError}
						labelFor={strings.verifyPassword} 
						labelText={strings.verifyPassword} 
						labelId={strings.verifyPassword} 
						inputType='password'
						textfieldClassType={this.props.textfieldClassType} 
						textfieldId={strings.verifyPassword} 
						textfieldPlaceholder={strings.verifyPassword} 
						textfieldName='verifyInput'
						value={this.state.verifyInput}
						textfieldForm={this.props.textFieldForm} 
						onChange={this.handleChange}
						onBlur={this.confirmChange} 
						errorMessageClassType={this.props.errorMessageClassType} 
						errorMessageText={strings.errorMessageVerifyPassword}
						required={true}
					/>

					<div className="disclaimer">
						<FormCheckbox onChange={this.handleChange} name="terms" />
						<p className="textParagraph" dangerouslySetInnerHTML={{ __html: `${strings.disclaimer}` }}></p>
					</div>
					{/* <div dangerouslySetInnerHTML={{ __html: `<p class="textParagraph color-accent1 text-center margin-top-10">${strings.disclaimer}</p>` }}/> */}

					<FormButton text={this.state.buttonData.text} iconClass={this.state.buttonData.loadingIcon} classType={`btn--fullWidth ${this.state.buttonData.class}`} />
	
				</form>
			)
		}
	}
	render() {
		return this.renderHandler();
	}
}

export default FormSignUp;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormSignUp/FormSignUp.jsx